import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getCustomerDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.CUSTOMER_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CUSTOMER_DETAILS_FAILURE });
        return error;
    }
}

export function* getSalesSelfBillDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.SALES_SELFBILL_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.SALES_SELFBILL_DETAILS_FAILURE });
        return error;
    }
}

export function* getCustomerPaymentDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.CUSTOMER_PAYMNET_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CUSTOMER_PAYMNET_DETAILS_FAILURE });
        return error;
    }
}


export function* getSalesInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SALES_INVOICE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.SALES_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getStoreSalesDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.STORE_SALES_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.STORE_SALES_DETAILS_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_MANAGEMENT_DETAILS_SUCCESS,
    });
}

export default function* salesManagementSaga() {
    yield all([
        takeEvery(actions.CUSTOMER_DETAILS_START, getCustomerDetails),
        takeEvery(actions.SALES_SELFBILL_DETAILS_START, getSalesSelfBillDetails),
        takeEvery(actions.CUSTOMER_PAYMNET_DETAILS_START, getCustomerPaymentDetails),
        takeEvery(actions.STORE_SALES_DETAILS_START, getStoreSalesDetails),
        takeEvery(actions.CLEAR_MANAGEMENT_DETAILS_START, getClearDetails)
    ]);
}